import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PresentationOptionsState {
  pptSlideCount: string;
  pptTargetLanguage: string;
  pptPresentationTone: string;
  pptTargetAudience: string;
  pptIncludeImages: boolean;
  technicalDepth: string;
}

const initialState: PresentationOptionsState = {
  pptSlideCount: "Auto",
  pptTargetLanguage: "Auto", 
  pptPresentationTone: "Auto",
  pptTargetAudience: "Auto",
  pptIncludeImages: false,
  technicalDepth: "Auto",
};

const presentationOptionsSlice = createSlice({
  name: 'presentationOptions',
  initialState,
  reducers: {
    setPptSlideCount: (state, action: PayloadAction<string>) => {
      state.pptSlideCount = action.payload;
    },
    setPptTargetLanguage: (state, action: PayloadAction<string>) => {
      state.pptTargetLanguage = action.payload;
    },
    setPptPresentationTone: (state, action: PayloadAction<string>) => {
      state.pptPresentationTone = action.payload;
    },
    setPptTargetAudience: (state, action: PayloadAction<string>) => {
      state.pptTargetAudience = action.payload;
    },
    setPptIncludeImages: (state, action: PayloadAction<boolean>) => {
      state.pptIncludeImages = action.payload;
    },
    setTechnicalDepth: (state, action: PayloadAction<string>) => {
      state.technicalDepth = action.payload;
    },
    resetToAuto: (state) => {
      state.pptSlideCount = "Auto";
      state.pptTargetLanguage = "Auto";
      state.pptPresentationTone = "Auto";
      state.pptTargetAudience = "Auto";
    },
  },
});

export const {
  setPptSlideCount,
  setPptTargetLanguage,
  setPptPresentationTone,
  setPptTargetAudience,
  setPptIncludeImages,
  setTechnicalDepth,
  resetToAuto,
} = presentationOptionsSlice.actions;

export default presentationOptionsSlice.reducer;